<template>
  <div class="project-list" :key="key" :data="$route.path">
    <div class="operate-box">
      <w-row type="flex" justify="space-between">
        <w-col class="tips-btn flex-1">
          <w-button size="small" type="primary" @click.stop="goAdd">
            <i class="r2-icon-content_add"></i><span>创建项目</span>
          </w-button>
        </w-col>
        <w-col class="project-category margin-right-10">
          <w-select class="type-select" size="small" v-model="queryParam.prjCategory" @change="projectFilter" placeholder="请选择">
            <w-option label="全部项目" :value="0"></w-option>
            <w-option label="协同项目" :value="1"></w-option>
          </w-select>
        </w-col>
        <w-col class="tips-search-date margin-right-10">
          <vue-datepicker-local format="YYYY" clearable v-model="queryParam.time"
                                placeholder="请选择年份"></vue-datepicker-local>
        </w-col>
        <w-col class="tips-search">
          <w-input size="small" ref="userNameInput" style="width: 220px;" v-model="queryParam.searchKey" @enter="search"
                   placeholder="输入关键字搜索">
            <i slot="prefix" class="r2-icon-action_search" style="fontSize: 20px!important; lineHeight: 32px;"></i>
            <i
              v-if="queryParam.searchKey!=''"
              class="r2-icon-nav_cancel cursor-pointer"
              style="lineHeight: 32px;"
              slot="suffix"
              @click="queryParam.searchKey='';search('')">
            </i>
          </w-input>
        </w-col>
        <w-col class="tips-type">
          <i
            :class="['r2-icon-editor_format_list_bulleted icon-type-change cursor-pointer float_left', moduleType === 'list' ? 'active' : '']"
            @click="changeModuleType('list')" v-if="moduleType === 'thumbnail'"></i>
          <i
            :class="['r2-icon-device_widgets_outlined icon-type-change cursor-pointer float_left', moduleType === 'thumbnail' ? 'active' : '']"
            @click="changeModuleType('thumbnail')" v-if="moduleType === 'list'"></i>
        </w-col>
      </w-row>
    </div>
    <div class="table-box" id="table-box">
      <!-- 列表展示区域 -->
      <div v-if="moduleType==='list'" class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height:tableHeight-(pagination.total>0?50:0)+'px',marginBottom:'1em'}" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" style="width: 100%;">
            <div class="header-item is-leaf" style="width: 130px;">项目编号</div>
            <div class="header-item is-leaf flex-1">项目名称</div>
            <div class="header-item is-leaf" style="width: 120px;">项目阶段</div>
            <div class="header-item is-leaf" style="width: 200px;">项目负责人</div>
            <div class="header-item is-leaf" style="width: 120px;">创建时间</div>
            <div class="header-item is-leaf" style="width: 200px;">创建人</div>
            <div class="header-item is-leaf is-operate" style="width: 80px;">操作</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" style="width: 100%;" ref="containerWrapper">
            <li class="flex flex-row row row--level-1" :class="item.recordStatus==1?'row_disable':''" v-for="(item, index) in data" :key="index">
              <div class="cell column_1" style="width: 130px;">
                {{item.prjNumber}}
              </div>
              <div class="cell column_2 flex-1">
                <editable-cell
                  :prj-category="item.prjCategory"
                  :module-type="moduleType"
                  :stage="item.stage"
                  :id="item.prjId"
                  :editable="item.editable || false"
                  :text="item.prjName"
                  :disabled="item.recordStatus==1"
                  @change="onCellChange(item.prjId, 'prjName', $event)"
                />
              </div>
              <div class="cell column_3" style="width: 120px;">
                {{item | statusFilter}}
              </div>
              <div class="cell column_4" style="width: 200px;">
                {{item.manager}}
              </div>
              <div class="cell column_4" style="width: 120px;">
                {{item.createTime | formatDate}}
              </div>
              <div class="cell column_4" style="width: 200px;">
                {{item.creatorName}}
              </div>
              <div class="cell column_5 is-operate" style="width: 80px;">
                <div style="width: 100%;">
                  <template v-if="item.recordStatus==1">
                    <span href="javascript:;">
                      <w-progress :percentage="50" :format="format"></w-progress>
                    </span>
                  </template>
                  <template v-else-if="(item.role==2 || item.role==4)&&!isAdmin">
                    <!--span href="javascript:;">
                        <i class="r2-icon-image_edit_outlined operation not-allowd cursor-not-allowed"></i>
                      </span>
                        <span href="javascript:;">
                        <i class="r2-icon-action_delete_outline operation not-allowd cursor-not-allowed"></i>
                      </span-->
                  </template>
                  <template v-else>
                    <el-tooltip content="重命名">
                      <span href="javascript:;" @click="editName(item)">
                      <i class="r2-icon-image_edit_outlined operation"></i>
                    </span>
                    </el-tooltip>
                    <el-tooltip content="删除">
                      <span href="javascript:;" @click="deleteHandel(item)">
                        <i class="r2-icon-action_delete_outline operation"></i>
                      </span>`
                    </el-tooltip>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 缩略图展示区域 -->
      <div v-else class="thumbnail">
        <ul class="project-wrapper"
            :style="{height: tableHeight - (pagination.total > 0 ? 50 : 0) + 'px', overflow: 'auto'}">
          <li class="project-item" :class="item.recordStatus==1?'':'cursor-pointer'" v-for="(item, index) in data"
              :key="index">
            <div class="project-box" @click.stop="previewProject(item)" @contextmenu="contextmenu(item, $event)">
              <div class="project-pic relative">
                <div v-if="item.recordStatus!==1 && !((item.role==2 || item.role==4) &&!isAdmin)" class="absolute more" style="right: 8px; top: 9px;z-index: 9;">
                  <w-dropdown @command="handlerAction" trigger="click">
                    <span class="w__dropdown-link" @click.stop="_clickHandle(item)">
                       <span class="more"><i class="r2-icon-nav_more_vert"
                                             style="font-size: 20px !important;"></i></span>
                    </span>
                    <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                      <w-dropdown-item :command="{item, type: 1, disable: (item.role==2 || item.role==4) &&!isAdmin}" class="1"
                                       :class="{'not-allowed cursor-not-allowed': (item.role==2 || item.role==4) &&!isAdmin}">重命名
                      </w-dropdown-item>
                      <w-dropdown-item :command="{item, type: 2, disable: (item.role==2 || item.role==4) &&!isAdmin}" divided
                                       :class="{'not-allowed cursor-not-allowed':(item.role==2 || item.role==4) &&!isAdmin}">删除
                      </w-dropdown-item>
                    </w-dropdown-menu>
                  </w-dropdown>
                </div>
                <img src="@/assets/images/building.png" width="212px" height="144px" alt="">
              </div>
              <div class="project-info relative">
                <div class="project-name ellipsis">
                  <editable-cell
                    :prj-category="item.prjCategory"
                    :module-type="moduleType"
                    :stage="item.stage"
                    :id="item.prjId"
                    :editable="item.editable || false"
                    :text="item.prjName+(item.recordStatus==1?'(备案中)':'')"
                    @change="onCellChange(item.prjId, 'prjName', $event)"
                  />
                  <!--<w-input size="small" v-model="item.prjName"></w-input>-->
                </div>
                <div class="project-other-info">
                  <div class="name">项目负责人</div>
                  <div class="text ellipsis">{{item.manager}}</div>
                </div>
                <div class="project-other-info">
                  <div class="name">项目阶段</div>
                  <div class="text ellipsis">{{item | statusFilter}}</div>
                </div>
                <div class="project-other-info">
                  <div class="name">创建时间</div>
                  <div class="text ellipsis">{{item.createTime | formatDate}}</div>
                </div>
              </div>
            </div>
          </li>
          <template v-if="data.length === 0">
            <li class="project-item">
              <div class="project-box empty">
                <div class="tips">暂无数据</div>
                <div class="project-pic">
                  <img src="@/assets/images/building.png" width="212px" height="144px" alt="">
                </div>
                <div class="project-info relative"></div>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <w-pagination
        style="paddingTop: 10px"
        class="text-align-right"
        v-if="pagination.total>0"
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="queryParam.pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pagination.pageSize"
        :page-sizes="[50, 100]"
        :total="pagination.total">
      </w-pagination>
      <context-menu :toggleShow="toggleShow" :position="position" :menuList="menuList"
                    @menuClick="menuClick"></context-menu>
    </div>

    <verify-code @dialogVisibleEvent='showVerify=false' :showVerify="showVerify" @verifyConfirm='verifyConfirm'></verify-code>
  </div>
</template>
<style lang="less">
  .row_disable {
    opacity: 0.7;
  }
  .datepicker {
    input {
      box-shadow: inset 0 0 0 1000px #fff !important;
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 32px !important;
      line-height: 32px !important;
      outline: none;
      padding: 0 15px;
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;

      &:focus {
        outline: none;
        border-color: #2079FA !important;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, .2) !important;
      }
    }

    .datepicker-popup {
      border-radius: 4px;
      border: 0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
    }
  }

  .w__tooltip {
    outline: 0;
  }
  .not-allowed {
    color: #ccc !important;
  }

  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
    background: rgba(243, 244, 247, 1);
  }
  .editable-cell-text-wrapper {
    display: flex;
    align-items: center;
    .project-icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      background-image: url("~@/assets/images/project/icon32.png");
      background-position: -100px -197px!important;
      &.marker {
        background-position: -100px -247px!important;
      }
    }
    .project-name {
      &.has-icon {
        max-width: calc(100% - 42px);
        &.thumbnail {
          max-width: calc(100% - 32px);
        }
      }
    }
    .pricing-collaboration {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin: 9px;
      background-image: url("~@/assets/images/project/pricing-collaboration.png");
    }
  }
</style>
<style lang="less" type="text/less" scoped>
  .project-list {
    width: 100%;
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    .tree-table .body-wrapper ul li>div.cell{
      font-size: 14px;
      height: 56px;
    }

    .tree-table .header-wrapper .table-header>.header-item{
      background-color: #f3f4f7;
      color: rgba(32, 37, 48, .8);
    }
    .operate-box {
      height: 52px;
    }

    .table-box {
      height: calc(100% - 52px);
    }

    .project-category {
      width: 110px;
    }

    .tips-search-date {
      width: 140px;
    }

    .tips-search {
      width: 220px;
    }

    .tips-type {
      width: 40px;

      i {
        width: 40px;
        padding: 2px;
        text-align: center;
        box-sizing: border-box;
        display: inline-block;

        &:hover {
          color: #2079FA;
        }
      }
    }

    .body-wrapper>ul>li:not(.row_disable) .editable-cell {
      cursor: pointer;
      &:hover {
        color: #2079fa;
      }
    }


    .operation {
      color: rgba(33, 37, 48, 0.55);;
      cursor: pointer;
      padding: 0 4px;

      &:hover {
        color: #2079fa;
      }
    }

    .not-allowd {
      color: #2125304f;

      &:hover {
        color: #2125304f;
      }
    }

    .project-wrapper {

      .project-item {
        width: 210px;
        height: 262px;
        display: inline-block;
        margin-bottom: 24px;
        margin-right: 20px;
        box-sizing: border-box;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;

        &:hover {
          .project-box:not(.empty) {
            box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
          }
        }

        &:last-child {
          margin-right: 0;
        }

        .project-box {
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          transition: all .3s cubic-bezier(.645, .045, .355, 1);

          &:not(.empty) {
            box-shadow:0px 2px 8px 0px rgba(33,37,48,0.15);
          }
          &:not(.empty):hover {
            box-shadow:0px 4px 16px 0px rgba(33,37,48,0.15);
          }
          .tips {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 9;
            background: #ffffff;
            color: #ccc;
            border: 1px dashed #eee;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .project-pic {
            background: #eeeeee;
            width: 212px;
            height: 144px;
            position: relative;

            .more {
              display: none;
              color: #2079FA;
            }

            &:hover {
              .more {
                display: block;
              }
            }
          }

          .project-info {
            height: 118px;
            padding: 0 16px;
            background: #fff;

            .project-name {
              margin-top: 6px;
              font-size: 14px;
              font-weight: 700;
              color: rgba(33, 37, 48, 1);
              line-height: 32px;

              &:focus, &:hover, &:visited {
                outline: none;
              }
            }

            .project-other-info {
              height: 24px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(33, 37, 48, 0.55);
              line-height: 24px;
              width: 100%;

              .name {
                width: 70px;
                display: inline-block;
                overflow: hidden;
              }

              .text {
                width: calc(100% - 70px);
                display: inline-block;
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
</style>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import VerifyCode from '@/components/VerifyCode'
import _ from 'lodash'
import {getCookie} from '@/assets/utils/CommonUtil'
import {on, off, clone} from '@/assets/utils/index'
import r2Project from '@/assets/service/r2Project'
import {formatDate} from '@/assets/utils/Date'
import spaceService from '@/assets/service/space'
import contextMenu from '@/components/common/contextMenu/Index'
import {mapMutations} from 'vuex'
import LoginService from '@/assets/service/login'

// 表头数据
const EditableCell = {
  template: `
    <div class="editable-cell" @click.stop="">
      <div v-if="editable" class="editable-cell-input-wrapper">
        <w-input size="small" placeholder="请输入内容" autofocus v-model="value" @pressEnter="check" @blur.stop="check"></w-input>
      </div>
      <div v-else @click="gotoDetail" class="editable-cell-text-wrapper ant-table-row-cell-ellipsis">
        <div v-if="moduleType === 'list'" style="width: 32px;height: 32px;margin-right: 10px;">
          <i class="project-icon" :class="{'marker': isPricingCollaboration}"></i>
        </div>
        <span :title="moduleType === 'thumbnail' ? value : ''" :class="{'has-icon': isPricingCollaboration, 'thumbnail ellipsis-1': moduleType === 'thumbnail'}" class="inline-block project-name">{{ value || ' ' }}</span>
        <template v-if="isPricingCollaboration && moduleType === 'thumbnail'">
          <el-tooltip content="计价协同项目">
            <i class="pricing-collaboration"></i>
          </el-tooltip>
        </template>
      </div>
    </div>
  `,
  props: {
    prjCategory: {
      type: Number,
      default: 0
    },
    moduleType: String,
    text: String,
    id: String,
    disabled: Boolean,
    editable: {
      type: Boolean,
      default: false
    },
    stage: String
  },
  data () {
    return {
      value: this.text,
      isPricingCollaboration: (this.prjCategory === 1)
    }
  },
  methods: {
    ...mapMutations({
      setPath: 'project/SET_PATH'
    }),
    check () {
      this.$emit('change', this.value)
    },
    gotoDetail () {
      if (this.disabled) {
        return
      }
      let status = this.stage ? this.stage : '全部文件'
      this.setPath(this.$route.path)
      this.$router.push({path: `${this.id}/files/${status}`, query: {prjName: this.text}})
    }
  }
}
// let isAdmin
// let role
// switch (+getCookie('role')) {
//   case 1:
//     role = '管理员'
//     break
//   case 2:
//     role = '总负责人'
//     break
//   case 3:
//     role = '档案室负责人'
//     break
//   case 4:
//     role = '普通员工'
//     break
//   default:
//     role = '管理员'
//     break
// }
export default {
  name: 'ProjectList',
  components: {
    EditableCell,
    contextMenu,
    VueDatepickerLocal,
    VerifyCode
  },
  data () {
    return {
      showVerify: false,
      phone: null,
      key: Date.now(),
      scrollY: false,
      loading: false,
      moduleType: 'thumbnail', // thumbnail
      deleteItem: null, // 正在执行删除操作的 行数据
      page: this.$route.path.indexOf('/all/') > -1,
      data: [], // 项目列表
      renameObj: {},
      pagination: {
        total: 0,
        pageSize: 50,
        defaultPageSize: 50,
        pageSizeOptions: ['50', '100'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      queryParam: {
        // 查询参数
        pageNum: 1, // 第几页
        pageSize: 50, // 每页中显示数据的条数
        searchKey: '',
        year: '',
        time: '',
        prjCategory: 0
      },
      currentRow: {},
      position: {
        left: 0,
        top: 0,
        bottom: 0
      },
      menuList: [
        {name: '重命名', type: 1, disabled: false},
        {name: '删除', type: 2, divided: true, disabled: false}
      ],
      toggleShow: false,
      isAdmin: false
    }
  },
  computed: {},
  watch: {
    'queryParam.search': function () {
    },
    'queryParam.time': function () {
      this.sentLog(100112004)
      if (this.queryParam.time) {
        this.queryParam.year = this.queryParam.time.getFullYear()
      } else {
        this.queryParam.year = ''
      }
    },
    'queryParam.year': function () {
      this.search()
    }
  },
  filters: {
    statusFilter: function (obj) {
      if (obj.prjType === '1') {
        let objq = Object.assign({}, obj.prjStatus)
        let str = Object.keys(objq)[Object.values(objq).lastIndexOf(1)]
        str = str ? str.replace(/(资料|文件)/, '阶段') : ''
        obj.stage = str || '评估阶段'
        return str
      } else {
        return '其他工程'
      }
    },
    roleFilter: function (role) {
      if (role === 1 || this.isAdmin) {
        return '项目管理'
      } else if (role === 2) {
        return '项目编辑'
      } else {
        return ''
      }
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  created () {
    this.isAdmin = this.hasModuleAuth('zjy_module_project_zsxmk_wcyd_manage') || this.hasModuleAuth('zjy_module_project_zsxmk_qbxm_manage')
  },
  beforeDestroy () {
    off(window, 'click', this._clickHandle)
    this._clickHandle = null
  },
  mounted () {

    on(window, 'click', this._clickHandle)
    this.init()
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    setTimeout(() => {
      this.tableHeight = this.getTableHeight('table-box') - (this.data.length > 0 ? 0 : 0)
    }, 200)
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.tableHeight = this.getTableHeight('table-box') - (this.data.length > 0 ? 0 : 0)
    })
    if (this.$microAppRouter) {
      const projectDetailPath = sessionStorage.getItem('projectDetailPath')
      sessionStorage.removeItem('projectDetailPath')
      this.$nextTick(() => {
        setTimeout(() => {
          projectDetailPath && this.$router.push({path: projectDetailPath})
        }, 300)
      })
    }
  },
  methods: {
    ...mapMutations({
      setPath: 'project/SET_PATH'
    }),
    // 关闭右键菜单
    _clickHandle () {
      this.toggleShow = false
    },
    // 切换类型
    changeModuleType (type = 'list') {
      this.moduleType = type
      this.sentLog(100112008, {type: type === 'list' ? 1 : 2})
    },
    // 1.1 初始化
    init () {
      this.getProjectList()
    },
    // 1.2 获取项目列表
    getProjectList () {
      let api = 'getPrjList'
      if (this.page) {
        api = 'getAllPrjList'
      }
      this.loading = true
      this.data = []
      r2Project[api](this.queryParam).then(res => {
        this.loading = false
        if (+res.code === 200) {
          this.data = res.data.items
          const pagination = {...this.pagination}
          pagination.total = res.data.totalCount
          this.pagination = pagination
        } else {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '请求列表失败！'
          })
        }
      }).catch(() => {
        this.$message.error('请求列表失败！')
        // this.$loading.hide()
      })
    },
    // 1.3 调用查询接口为dataSource 赋值
    handleCurrentChange (index) {
      this.pagination.current = index
      this.queryParam.pageNum = index
      this.getProjectList()
    },
    handlePageSizeChange (index) {
      this.pagination.pageSize = index
      this.queryParam.pageSize = index
      this.pagination.current = 1
      this.queryParam.pageNum = 1
      this.getProjectList()
    },
    // 1.4 调用查询接口为dataSource 赋值
    getTableList () {
      this.loading = true
      retriveHosData(this.queryParam).then(res => {
        if (res.message === 'SUCCESS') {
          const pagination = {...this.pagination}
          pagination.total = res.data.total
          this.tableDatas = res.data.list
          this.pagination = pagination
        }
        this.loading = false
      })
    },
    // 1.5 响应重命名
    editName (dataIndex, logType = '100112007') {
      dataIndex.editable = true
      this.$forceUpdate()
      this.sentLog(logType)
    },
    // 1.6 重命名
    onCellChange (id, dataIndex, value) {
      value = value.replace(/(^\s*)|(\s*$)/g, '')
      let reg = new RegExp('[/\\n\\"\'+%<>|:?*]')
      if (
        value.match(reg) ||
        value.indexOf('/') > -1 ||
        value.indexOf('\\') > -1
      ) {
        this.$message.warning('该文件名有特殊字符，请使用其它名称！')
        return
      }
      if (value === '') {
        this.$message.warning('文件名不能为空！')
        return
      }
      if (value.length > 100) {
        this.$message.warning('文件名最大可输入100个字！')
        return
      }
      this.renameServer(id, dataIndex, value)
    },
    // 1.7 重命名请求
    renameServer (id, dataIndex, value) {
      const data = [...this.data]
      let oldName
      const target = data.find(item => item.prjId === id)
      if (target) {
        if (target[dataIndex] === value) {
          target.editable = false
          this.$forceUpdate()
          return
        }
        oldName = target[dataIndex]
        target[dataIndex] = value
        target.editable = false
        this.data = data
      }
      let params = {
        prjName: value,
        projectId: id
      }
      r2Project.renamePrj(params).then(data => {
        if (+data.code === 200) {
          // 操作记录
          this.addOperationRecords(12, oldName + '->' + value, {}, id)
        } else if (+data.code === 10005) {
          this.$message.warning('项目不存在')
          this.getProjectList()
          return false
        } else if (data.message) {
          this.getProjectList()
          this.$confirm({
            message: data.message,
            title: '提示',
            submit: data => {
            },
            submitText: '确定',
            noCancelBtn: true
          })
        }
      })
    },
    // 查看项目详情
    previewProject ({prjId, prjName, recordStatus, editable, stage}) {
      let status = stage || '全部文件'
      if (+recordStatus === 1 || editable) {
        return
      }
      this.setPath(this.$route.path)
      this.$router.push({path: `${prjId}/files/${status}`, query: {prjName}})
    },
    // 右键菜单
    contextmenu (item, event) {
      // 阻止默认右键点击事件
      if (event.preventDefault) {
        event.preventDefault()
      } else {
        event.returnValue = false
      }
      this.currentRow = item
      if (+item.recordStatus === 1) {
        return
      }
      if ((item.role === 2 || item.role === 4) && !this.isAdmin) {
        this.menuList.map(item => {
          item.disabled = true
        })
      } else {
        this.menuList.map(item => {
          item.disabled = false
        })
      }
      // 获取右键坐标
      let maxWidth = document.body.clientWidth
      let maxHeight = document.body.clientHeight
      if (maxHeight - event.clientY < 100) {
        this.position.top = 0
        this.position.bottom = (maxHeight - event.clientY)
      } else {
        this.position.top = event.clientY
        this.position.bottom = 0
      }
      if (maxWidth - event.clientX < 100) {
        this.position.left = 0
        this.position.right = (maxWidth - event.clientX)
      } else {
        this.position.left = event.clientX
        this.position.right = 0
      }
      // 菜单出现的flag
      this.toggleShow = true
      // 显示弹出窗
    },
    handlerAction ({item, type, disable}) {
      if (+item.recordStatus === 1 || disable) {
        return
      }
      this.currentRow = item
      this.menuClick({type}, {}, false)
    },
    // 右键菜单点击
    async menuClick ({type}, item = {}, logType = true) {
      this.toggleShow = false
      let {prjId, prjName} = this.currentRow
      if (type === 1) {
        this.editName(this.currentRow, logType ? '100112006' : '100112007')
      } else if (type === 2) {
        // let flag = await this.isDoubleVerify()
        // if (flag) {
        //   return false
        // }
        this.$confirm({
          message: '确定删除该项目？',
          type: 'warning',
          width: 400,
          submit: () => {
            this.onDelete(prjId, prjName, logType ? '100112009' : '100112010')
          }
        })
      }
      this.key = Date.now()
    },
    // // 判断是否已经二次验证
    // async isDoubleVerify (){
    //   const userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
    //   this.phone = userinfo.passwordMobile
    //   let result = await new Promise((resolve, reject) => {
    //     LoginService.isDoubleVerify(userinfo.passwordMobile).then(res => {
    //       if (res.code === 200){
    //         if (res.data){ // 需要二次验证-弹出弹框
    //           console.log('未二次验证！')
    //           this.showVerify = true
    //           resolve(true)
    //         } else { // 已经验证过
    //           console.log('二次验证已通过！')
    //           resolve(false)
    //         }
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   })
    //   return result
    // },

    // 二次验证---确定
    verifyConfirm (){
      console.log('验证成功，请继续操作！')
    },
    // 删除确定弹框
    async deleteHandel (data) {

      // let flag = await this.isDoubleVerify()
      // if (flag) {
      //   return false
      // }
      let {prjId, prjName} = data
      this.$confirm({
        message: '确定删除该项目？',
        type: 'warning',
        width: 400,
        submit: () => {
          this.onDelete(prjId, prjName)
        }
      })
    },
    // 项目类型筛选
    projectFilter () {
      this.search()
    },
    // 2.1 删除 确定
    async onDelete (id, name, logType = '100112010') {
      // let flag = await this.isDoubleVerify()
      // if (flag) {
      //   return false
      // }
      let params = {
        projectId: id
      }
      spaceService.deleteProject(params).then(data => {
        if (+data.code === 200) {
          // 操作记录
          this.addOperationRecords(11, name, {}, id)
          this.getProjectList()
        } else {
          this.$confirm({
            message: data.message,
            noCancelBtn: true,
            submit: () => {
              this.getProjectList(true)
            }
          })
        }
      })
      this.sentLog(logType)
    },
    // 2.2 搜索
    search: _.debounce(function (data) {
      this.sentLog(100112005, {message: this.queryParam.searchKey})
      let api = 'getSearchJoinedPrjs'
      if (this.page) {
        api = 'getSearchAllPrjs'
      }
      this.pagination.total = 0
      this.pagination.current = 1
      this.queryParam.pageNum = 1
      // this.queryParam.key = data
      this.loading = true
      this.data = []
      const params = clone(this.queryParam)
      if (params.prjCategory === 0) {
        delete params.prjCategory
      }
      r2Project[api](params).then(res => {
        this.loading = false
        if (+res.code === 200) {
          this.data = res.data.items
          const pagination = {...this.pagination}
          pagination.total = res.data.totalCount
          this.pagination = pagination
        } else {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '请求列表失败！'
          })
        }
      }).catch(() => {
        this.$message.error('请求列表失败！')
        // this.$loading.hide()
      })
    }, 100),
    // 2.3 创建
    goAdd () {
      this.setPath(this.$route.path)
      this.$router.push({name: 'prjAdd'})
      this.sentLog(100112003)
    },
    // 2.4 备案进度显示
    format (percentage) {
      return '备案中'
    }
  }
}
</script>
